__webpack_require__.p = "https://chambaticon-test.ticongle.com/";